import { shouldShowTimedBanner } from '../utils';
import { useBackfillShallowStore } from './use-backfill-store';
import { useCallIntelTrial } from './use-call-intel-trial';
import { usePermanentDismissOnVisit } from './use-permanent-dismiss-on-visit';

/**
 * Determines whether the batch-2-complete (fully complete) global banner should be visible.
 *
 * Conditions (all must be true):
 * - At least one location has an active CI trial
 * - User has CALL_INTELLIGENCE_READ permission on trial locations
 * - Full 30-day backfill is complete
 * - Banner has not been dismissed (or 7 days have passed without visiting CI)
 */
export const useBackfillBatch2BannerVisibility = () => {
  const { hasTrialAccess, isOnCallIntelligenceRoute, hasTrialLocations, isFullyComplete, hasPartialRecordingHistory } =
    useCallIntelTrial();
  const { batch2CompleteBannerDismiss, dismissBatch2CompleteBanner } = useBackfillShallowStore(
    'batch2CompleteBannerDismiss',
    'dismissBatch2CompleteBanner'
  );

  usePermanentDismissOnVisit({
    dismissState: batch2CompleteBannerDismiss,
    isOnCallIntelligenceRoute,
    onDismiss: dismissBatch2CompleteBanner,
    shouldDismiss: isFullyComplete,
  });

  const isVisible =
    hasTrialLocations && hasTrialAccess && isFullyComplete && shouldShowTimedBanner(batch2CompleteBannerDismiss);

  return {
    dismiss: dismissBatch2CompleteBanner,
    isOnCallIntelligenceRoute,
    isVisible,
    hasPartialRecordingHistory,
  };
};
